module.exports = __webpack_public_path__ + "static/media/19.53fa9ba0.jpg";